<template>
	<div class="home">
		<!-- banner -->
		<div class="top">
			<div class="page banner">
				<div class="h1">运营商<span class="redText">官方</span>合作伙伴</div>
				<div class="des">超高佣金、超好服务、超多产品</div>
				<div class="des">做号卡，选靓号帮</div>
				<div class="enterBtn flexc">点击进入</div>
			</div>
		</div>
		<!-- 关于我们 -->
		<div class="about">
			<div class="page">
				<div class="title">关于我们</div>
				<div class="about-des">
					河南靓号帮网络科技有限公司，成立于2022年，注册资本1000万元。公司总部建设于郑州，目前团队已有50+人，团队理念为，用心帮助每一位客户解决售后问题，团队宗旨为：细节决定成败，态度决定未来。
					致力于成为领先的服务类广告营销云平台，帮助客户选择自己喜欢的号码，通过精准营销（CPA/S）+SCRM销售深耕服务行业，以及优秀的售后服务态度，深受客户的喜爱与支持，目前已是通讯行业头部的线上代理商（全国手机靓号、移动、电信、联通的套餐、号卡）。
				</div>
				<div class="more flexc" @click="learnMore()">了解更多</div>
			</div>
		</div>
		<!-- 公司优势 -->
		<div class="advantage">
			<div class="page">
				<div class="title" style="margin-bottom: 0.3125rem">公司优势</div>
				<div class="flexb" style="margin-bottom: 0.25rem">
					<div class="imgBox">
						<img src="@/static/imgs/advantage1.png" alt="" />
						<div style="position: absolute; top: 0; left: 0">
							<div class="advantage-title">资源（产品）优势</div>
							<div class="advantage-des">
								各大运营商都有，也会第一时间上架新产品
							</div>
						</div>
					</div>
					<div class="imgBox">
						<img src="@/static/imgs/advantage2.png" alt="" />
						<div style="position: absolute; top: 0; left: 0">
							<div class="advantage-title">代理模式优势</div>
							<div class="advantage-des">
								免费给客户注册，免费推广，同时拥有比较好的等级模式以及每个等级的奖励
							</div>
						</div>
					</div>
					<div class="imgBox">
						<img src="@/static/imgs/advantage3.png" alt="" />
						<div style="position: absolute; top: 0; left: 0">
							<div class="advantage-title">分佣优势</div>
							<div class="advantage-des">
								两大返佣金模式，次月返当月返这两大模式，不卡时间，只要通过即可返佣金
							</div>
						</div>
					</div>
				</div>
				<div class="flexb">
					<div class="imgBox" style="flex: 1">
						<img src="@/static/imgs/advantage4.png" alt="" />
						<div style="position: absolute; top: 0; left: 0">
							<div class="advantage-title">后端支持</div>
							<div class="advantage-des">
								支持自定义配置网页版后台的登录站点名称，也可以帮助代理商打造自己的号卡品牌，并且可以选择配置绑定自己的独立域名，更高程度的提升自己的品牌形象
							</div>
						</div>
					</div>
					<div class="imgBox">
						<img src="@/static/imgs/advantage5.png" alt="" />
						<div style="position: absolute; top: 0; left: 0">
							<div class="advantage-title">发货优势</div>
							<div class="advantage-des">
								发货速度快，几乎三天内就可以收货，也支持手机扫码随时查询
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 核心业务 -->
		<div class="business">
			<div class="page">
				<div class="title">核心业务</div>
				<div class="business-bg">
					<div class="business-top">
						<div class="business-title">靓号</div>
						<div class="business-des" style="margin-bottom: 0.1979rem">
							公司与移动 电信
							 联通三大电信运营商均为正规合作，致力于为客户提供自己喜欢的靓号，选择自己喜欢的号码，靓号又被称为“吉祥号码”，不同的号码对不同的人也有着特殊的意义，生日号码，纪念日号码等。不仅是为了身份的象征，更为了让客户有更多选择的机会
						</div>
						<div class="business-btn flexc" @click="business(1)">
							点击进入
							<img src="@/static/imgs/enter-icon.png" alt="" />
						</div>
					</div>
				</div>
				<div class="flexb">
					<div class="business-bg2" style="background-color: #4391f4">
						<div class="business-top" style="background-color: #f1f6fd; height: 2.9271rem">
							<div class="business-title mb24">分销</div>
							<div class="business-des">
								1.精准流量 + SCRM
								系统驱动转化（依托字节、腾讯等平台精准获客，深度用户行为分析）。
							</div>
							<div class="business-des">
								2.多级分销 + 高佣金激励（卡商 / 卡友二级体系，分佣比例高达
								50%，激发推广积极性）
							</div>
							<div class="business-des">
								3.技术赋能自动化管理（SaaS
								系统支持独立后台、订单追踪、防套卡拦截等全流程智能操作）
							</div>
							<div class="business-des">
								4.多元渠道与内容创新（直播带货、社交媒体裂变结合企业采购，覆盖多元用户群体）
							</div>
							<div class="business-des">
								5.培训与晋升机制完善（系统化培训 +
								清晰晋升通道，高薪酬激励团队成长）
							</div>
							<div class="business-des" style="margin-bottom: 0.1563rem">
								6.运营商合作保障号源合规（整合全国号池，提供担保交易与售后服务）
							</div>
							<div class="business-btn flexc" @click="business(2)">
								点击进入
								<img src="@/static/imgs/enter-icon.png" alt="" />
							</div>
						</div>
					</div>
					<div class="business-bg2" style="background-color: #2abb6d">
						<div class="business-top" style="background-color: #f0f9f4; height: 2.9271rem">
							<div class="business-title mb24">直播</div>
							<div class="business-des">
								1.流量精准触达，字节/腾讯/快手战略流量池
							</div>
							<div class="business-des">2.CPA成本降低40%，转化效率倍增</div>
							<div class="business-des">3.AI选号：3秒精准匹配</div>
							<div class="business-des">4.套餐对比：资费/流量可视化</div>
							<div class="business-des">5.限时直降：直播价=官网价7折</div>
							<div class="business-des">
								6.信任三重保障，运营商授权书实时验真
							</div>
							<div class="business-des">
								7.用户数据国标级加密，7×24小时在线锁单
							</div>
							<div class="business-des" style="margin-bottom: 0.625rem">
								8.技术长效赋能，区块链号卡溯源
							</div>

							<div class="business-btn flexc" @click="business(3)">
								点击进入
								<img src="@/static/imgs/enter-icon.png" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- APP介绍 -->
		<div class="app-introduce">
			<div class="page">
				<div class="title">APP介绍</div>
				<div class="app-title">
					靓号帮 APP
					是河南靓号帮网络科技有限公司自主研发的通讯服务平台，专注于为用户提供便捷、安全的号卡服务，其核心功能及特点如下：
				</div>
				<div class="app-content flex">
					<div class="app-left">
						<div class="red-btn flexc mb48">核心功能</div>
						<div class="mb48">技术与安全</div>
						<div class="mb48">用户体验优化</div>
						<div class="mb48">附加服务</div>
						<div>平台优势</div>
					</div>
					<div class="app-right">
						<div class="mb24">
							<div class="right-title">靓号选购</div>
							<div class="right-des">
								支持在线筛选全国及本地靓号，涵盖吉祥号、顺子号、情侣号、生日号等稀缺号码资源，满足个性化需求。
							</div>
						</div>
						<div class="mb24">
							<div class="right-title">流量卡办理</div>
							<div class="right-des">
								提供三大运营商（移动、联通、电信）及虚拟运营商（如小米、京东）的高性价比套餐，包括
								5G 高速流量卡、定向流量卡等，支持在线实名认证及激活。
							</div>
						</div>
						<div class="mb24">
							<div class="right-title">订单追踪</div>
							<div class="right-des">
								实时查看订单状态（制卡、运输、激活），全流程透明化
							</div>
						</div>
						<div>
							<div class="right-title">客服支持</div>
							<div class="right-des">内置开卡及售后客服，及时解决用户疑问</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 新闻资讯 -->
		<div class="news">
			<div class="page">
				<div class="title" style="margin-bottom: 106px">新闻资讯</div>
				<div class="flex" v-for="i in newLists" :key="i.id" style="
            border-bottom: 1px solid #f0f0f0;
            padding-bottom: 24px;
            margin-bottom: 44px;
            cursor: pointer;
          " @click="goNews">
					<div>
						<img :src="i.titleImgUrl" style="
                width: 0.6563rem;
                height: 0.4896rem;
                margin-right: 0.0625rem;
              " />
					</div>

					<div>
						<div class="newsTitle">{{ i.title }}</div>
						<div class="newsDes">{{ i.details }}</div>
						<div class="newsTime">{{ i.createTime }}</div>
					</div>
				</div>
				<div style="margin-top: 80px; margin-bottom: 70px">
					<el-pagination background layout="prev, pager, next" :total="total" @change="pageChange($event)" />
				</div>
			</div>
		</div>
		<!-- 底部 -->
		<footer>
			<div class="page flexa">
				<div>
					<div class="mb24">河南靓号帮网络科技有限公司</div>
					<img src="@/static/imgs/logo.png" alt="" style="
              width: 0.5208rem;
              height: 0.5208rem;
              margin: 0 auto;
              display: block;
            " />
				</div>
				<div>
					<div class="mb24">寻求合作</div>
					<div class="mb24">我要购卡</div>
					<div>APP下载</div>
				</div>
				<div class="contact" style="">
					<div class="mb24">实时动态与我们联系</div>
					<div class="mb12">地址：郑州市管城区御玺大厦A座2406室</div>
					<div class="mb12">电话：16710987654</div>
					<div>邮箱：caimc88@bei-min.com</div>
				</div>
			</div>
		</footer>
		<div class="last">版权所有©河南靓号帮网络科技有限公司
			<a href="https://beian.miit.gov.cn/#/Integrated/index">豫ICP备2023011910号-1</a>
		</div>

	</div>
</template>

<script setup>
	import {
		newsList
	} from "@/request/api.js";
	import {
		ref,
		reactive,
		onMounted
	} from "vue";
	import {
		useRouter
	} from "vue-router";
	import {
		useStore
	} from "vuex";
	const store = useStore();
	const router = useRouter();
	const num = ref(1);
	const total = ref("");
	const activeName = ref("首页");
	const tabList = reactive([
		"首页",
		"关于我们",
		"公司优势",
		"核心业务",
		"APP介绍",
		"新闻资讯",
		"联系我们",
	]);
	const params = ref({
		pageNum: 1,
		pageSize: 10,
	});

	const newLists = ref([]);
	async function getList() {
		const res = await newsList(params.value);
		if (res.code == 200) {
			newLists.value = res.rows;
			total.value = res.total;
		}
	}
	const pageChange = (e) => {
		console.log(e);
		params.value.pageNum = e;
		getList();
	};
	onMounted(() => {
		getList();
		window.scrollTo(0, 0);
	});
	const learnMore = () => {
		router.push("/about");
		store.commit("changeTabs", "关于我们");
	};
	const business = (num) => {
		router.push("/business?type=" + num);
		store.commit("changeTabs", "核心业务");
	};
	//
	const goNews = () => {
		router.push("/news");
		store.commit("changeTabs", "新闻资讯");
	};
</script>
<style scoped>
	html,
	body {
		overflow-x: hidden;
	}

	.home {
		width: 10rem;
		font-family: "PingFangMedium";
	}

	.page {
		width: 6.25rem;
		margin: 0 auto;
	}

	.flex {
		display: flex;
		align-items: center;
	}

	.flexb {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.flexa {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.mr48 {
		margin-right: 0.25rem;
	}

	.mb24 {
		margin-bottom: 0.125rem;
	}

	.mb48 {
		margin-bottom: 0.25rem;
	}

	/deep/ .el-pagination {
		justify-content: center;
	}

	header {
		height: 0.4167rem;
		background: #f2f5fa;
		box-sizing: border-box;
	}

	.header {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.tabs {
		font-size: 0.0938rem;
		font-family: "PingFangBold";
	}

	.top {
		height: 3.4896rem;
		background-image: url("@/static/imgs/home-bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		box-sizing: border-box;
		background-position: 0 -0.3646rem;
		/* 垂直方向上移  */
	}

	.banner {
		box-sizing: border-box;
		padding-top: 0.7969rem;
	}

	.h1 {
		font-size: 0.2708rem;
		color: #333333;
		font-family: "PingFangHeavy";
		margin-bottom: 0.1354rem;
	}

	.des {
		font-size: 0.0938rem;
		color: #333333;
		margin-bottom: 16px;
	}

	.redText {
		color: #e5432c;
	}

	.enterBtn {
		width: 1.2552rem;
		height: 0.3125rem;
		background: linear-gradient(90deg, #ff7a27 0%, #e5432c 100%);
		border-radius: 0.2083rem;
		font-size: 0.1458rem;
		color: #fff;
		font-family: "PingFangBold";
		/* padding-left: 0.125rem; */
		box-sizing: border-box;
		margin-top: 0.349rem;
	}

	.about {
		height: 2.4844rem;
		padding-top: 0.4167rem;
		box-sizing: border-box;
	}

	.title {
		font-size: 0.1979rem;
		font-family: "PingFangBold";
		color: #333333;
		text-align: center;
	}

	.about-des {
		font-size: 0.0938rem;
		color: #333333;
		line-height: 0.151rem;
		margin-top: 48px;
	}

	.advantage {
		height: 4.3698rem;
		background: #f9fbff;
		padding-top: 0.4271rem;
	}

	.flexc {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.more {
		width: 0.8854rem;
		height: 0.1979rem;
		background: linear-gradient(90deg, #ff7a27 0%, #e5432c 100%);
		border-radius: 0.2083rem;
		font-size: 0.0729rem;
		color: #ffffff;
		margin: 0 auto;
		margin-top: 0.25rem;
		cursor: pointer;
	}

	.imgBox {
		width: 1.9167rem;
		height: 1.375rem;
		position: relative;
	}

	.imgBox img {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}

	.advantage-title {
		margin: 0.3854rem 0 0.3125rem 0.125rem;
		font-size: 0.1146rem;
		font-family: "PingFangBold";
		color: #333333;
	}

	.advantage-des {
		font-size: 0.0938rem;
		color: #ffffff;
		padding: 0 0.125rem;
	}

	.business {
		height: 6.4479rem;
		padding-top: 0.4167rem;
	}

	.business-top {
		width: 100%;
		/* height: 1.4323rem; */
		background: #fdf0f0;
		border-radius: 0.1042rem;
		margin-bottom: 0.3125rem;
		padding: 0.125rem;
		box-sizing: border-box;
		position: absolute;
		left: 0;
		top: 0.0208rem;
		padding-bottom: 0.1979rem;
	}

	.business-bg {
		margin-top: 0.4375rem;
		width: 100%;
		height: 1.0052rem;
		background: #e5432c;
		border-radius: 0.1042rem;
		position: relative;
		margin-bottom: 0.7448rem;
	}

	.business-bg2 {
		width: 3rem;
		height: 2.4531rem;
		position: relative;
		border-radius: 0.1042rem;
	}

	.business-title {
		font-size: 0.1146rem;
		font-family: "PingFangBold";
		color: #333333;
	}

	.business-des {
		font-size: 0.0938rem;
		color: #666666;
		margin-bottom: 0.0417rem;
	}

	.business-btn {
		width: 1.125rem;
		height: 0.3125rem;
		background: linear-gradient(90deg, #ff7a27 0%, #e5432c 100%);
		border-radius: 0.2083rem;
		font-size: 0.1458rem;
		font-family: "PingFangBold";
		color: #ffffff;
		float: right;
		cursor: pointer;
	}

	.business-btn img {
		width: 0.1354rem;
		height: 0.1354rem;
	}

	.app-introduce {
		height: 4.2135rem;
		background-image: url("@/static/imgs/app-bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		box-sizing: border-box;
		padding-top: 0.4167rem;
	}

	.app-title {
		font-size: 0.0938rem;
		color: #666666;
		margin: 0.4167rem 0 0.125rem;
	}

	.app-content {
		width: 100%;
		/* height: 2.224rem; */
		background: #ffffff;
		border-radius: 0.1042rem;
	}

	.app-left {
		width: 1.0729rem;
		text-align: center;
		background: #f9fbff;
		border-radius: 0.1042rem 0px 0px 0.1042rem;
		padding: 0.1667rem 0.0625rem;
		box-sizing: border-box;
	}

	.red-btn {
		width: 0.9479rem;
		height: 0.2448rem;
		background: linear-gradient(90deg, #ff7a27 0%, #e5432c 100%);
		border-radius: 0.026rem;
		font-size: 0.1146rem;
		font-family: "PingFangBold";
		color: #ffffff;
	}

	.app-right {
		box-sizing: border-box;
		padding: 0.1667rem 0.1875rem;
	}

	.right-title {
		font-family: "PingFangBold";
		font-size: 0.1042rem;
		color: #333333;
		margin-bottom: 0.0313rem;
	}

	.right-des {
		font-size: 0.0938rem;
		color: #666666;
	}

	.news {
		/* height: 5.5417rem; */
		padding-top: 0.6198rem;
		box-sizing: border-box;
	}

	footer {
		height: 1.2969rem;
		background: #20232a;
		font-size: 0.0938rem;
		color: #ffffff;
		box-sizing: border-box;
		font-family: "PingFangBold";
		padding-top: 0.2396rem;
	}

	.contact {
		font-size: 0.0833rem;
		color: #666666;
		font-family: "PingFangMedium";
	}

	.last {
		height: 0.2771rem;
		background: #090f22;
		font-size: 0.0729rem;
		color: #666666;
		font-family: "PingFangMedium";
		text-align: center;
		line-height: 0.2771rem;
	}

	.newsTitle {
		font-size: 0.1042rem;
		font-family: "PingFangBold";
		color: #333333;
		margin-bottom: 10px;
	}

	.newsDes {
		width: 4.8021rem;
		font-size: 0.0938rem;
		margin-bottom: 0.0521rem;
		color: #666666;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.newsTime {
		font-size: 0.0729rem;
		color: #999999;
	}
</style>